import { useEffect } from 'react';

/**
 * 원본 main.js의 mobileMainMenu 함수 오버라이드 커스텀 훅
 * React에서 처리하므로 원본 함수 비활성화
 */
export const useMobileMenuOverride = () => {
  useEffect(() => {
    // 원본 JavaScript의 mobileMainMenu 함수가 실행되기 전에 오버라이드
    // 전역 함수로 노출하여 원본 main.js에서 호출해도 React에서 처리하도록 함
    // body-overlay-2는 JSX에서 이미 렌더링되므로 중복 생성 방지만 수행
    window.mobileMainMenu = function() {
      // React에서 이미 처리하므로 원본 함수는 실행하지 않음
      // body-overlay-2는 MainLayout JSX에서 이미 렌더링되므로 아무 작업도 하지 않음
    };
  }, []);
};
